import React, { useState } from "react";
import { SignUpContainer } from "./SignUpStyled";
import { FormattedMessage, useIntl } from 'react-intl';
import { Link, useNavigate } from "react-router-dom";

import close from './../../utils/images/close_circle.svg';
import eye from './../../utils/images/eye.svg';
import slashEye from './../../utils/images/slash_eye.svg';
import check_circle from './../../utils/images/check_circle.png';

import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import { utils } from '@hassanmojab/react-modern-calendar-datepicker';
import Select from 'react-select'
import { useEffect } from "react";
import { getAge } from "../../services/dateServices";
import Alert from "../../components/Alert/Alert";

import ModalSecurityCode from "../../components/ModalSecurityCode/ModalSecurityCode";
import { getCountries } from "../../api/filtersApi";
import { identificationTypes, primaryLanguageTypes } from "../../utils/constants/general";


export default function SignUp() {

    const intl = useIntl();
    const navigate = useNavigate();

    const [activeUser, setActiveUser] = useState('influencer');

    const [influencerName, setInfluencerName] = useState('');
    const [validInfluencerName, setValidInfluencerName] = useState(false);
    const [influencerLastName, setInfluencerLastName] = useState('');
    const [validInfluencerLastName, setValidInfluencerLastName] = useState(false);
    const [email, setEmail] = useState('');
    const [validEmail, setValidEmail] = useState(false);
    const [repetEmail, setRepetEmail] = useState('');
    const [validRepetEmail, setValidRepetEmail] = useState(false);
    const [password, setPassword] = useState('');
    const [validPassword, setValidPassword] = useState(false);
    const [seePassword, setSeePassword] = useState(false);
    const [typeInfluencerId, setTypeInfluencerId] = useState();
    const [typeInfluencerLanguage, setTypeInfluencerLanguage] = useState();
    const [influencerId, setInfluencerId] = useState();
    const [selectedDay, setSelectedDay] = useState(null);
    const [gender, setGender] = useState('');
    const [showCustomPronoun, setShowCustomPronoun] = useState();

    const [isUnderAge, setIsUnderAge] = useState(false);
    const [legalRepresentativeName, setLegalRepresentativeName] = useState('');
    const [validLegalRepresentativeName, setValidLegalRepresentativeName] = useState(false);
    const [legalRepresentativeLastName, setLegalRepresentativeLastName] = useState('');
    const [validLegalRepresentativeLastName, setValidLegalRepresentativeLastName] = useState(false);
    const [legalRepresentativeEmail, setLegalRepresentativeEmail] = useState('');
    const [validLegalRepresentativeEmail, setValidLegalRepresentativeEmail] = useState(false);
    const [legalRepresentativePhone, setLegalRepresentativePhone] = useState('');
    const [legalRepresentativeIndicativePhone, setLegalRepresentativeIndicativePhone] = useState('');
    const [validLegalRepresentativePhone, setValidLegalRepresentativePhone] = useState(false);
    const [relationship, setRelationship] = useState('');

    const [companyName, setCompanyName] = useState('');
    const [validCompanyName, setValidCompanyName] = useState(false);
    const [companyEmail, setCompanyEmail] = useState('');
    const [validCompanyEmail, setValidCompanyEmail] = useState(false);
    const [companyRepetEmail, setCompanyRepetEmail] = useState('');
    const [validCompanyRepetEmail, setValidCompanyRepetEmail] = useState(false);
    const [companyPassword, setCompanyPassword] = useState('');
    const [validCompanyPassword, setValidCompanyPassword] = useState(false);

    const [policyChecked, setPolicyChecked] = useState(false); //No se está yendo al back

    const [showSecurityCode, setShowSecurityCode] = useState(false);

    const [body, setBody] = useState({});

    const [showEmptyFieldsMessage, setShowEmptyFieldsMessage] = useState(false);
    const [showErrorPasswordMessage, setShowErrorPasswordMessage] = useState(false);
    const [showErrorCompanyPasswordMessage, setShowErrorCompanyPasswordMessage] = useState(false);

    const [indicativesOptions, setIndicativesOptions] = useState([]);

    const [showAlertSuccessful, setShowAlertSuccessful] = useState(false);
    const [showAlertUserExists, setShowAlertUserExists] = useState(false);

    useEffect(() => {
        getCountries().then((response) => {
            const auxIndicatives = [];
            response.map((country) => {
                auxIndicatives.push({ value: country.indicative, label: country.indicative })
            })
            setLegalRepresentativeIndicativePhone(auxIndicatives[0].label);
            setIndicativesOptions(auxIndicatives);
        })
    }, [])

    useEffect(() => {
        setShowEmptyFieldsMessage(false);

        if (influencerName.length > 0) {
            setValidInfluencerName(true)
        } else {
            setValidInfluencerName(false)
        }

        if (influencerLastName.length > 0) {
            setValidInfluencerLastName(true)
        } else {
            setValidInfluencerLastName(false)
        }

        if (companyName.length > 0) {
            setValidCompanyName(true)
        } else {
            setValidCompanyName(false)
        }

        if (legalRepresentativeName.length > 0) {
            setValidLegalRepresentativeName(true)
        } else {
            setValidLegalRepresentativeName(false)
        }

        if (legalRepresentativeLastName.length > 0) {
            setValidLegalRepresentativeLastName(true)
        } else {
            setValidLegalRepresentativeLastName(false)
        }


        if (legalRepresentativePhone.length > 8) {
            setValidLegalRepresentativePhone(true)
        } else {
            setValidLegalRepresentativePhone(false)
        }

    }, [influencerName, influencerLastName, companyName, legalRepresentativeName, legalRepresentativeLastName, legalRepresentativePhone, policyChecked])

    useEffect(() => {
        setShowEmptyFieldsMessage(false);
        const expRegEmail = new RegExp('[a-z0-9]+@[a-z]+[.][a-z]{2,3}');
        if (expRegEmail.test(email)) {
            setValidEmail(true);
        } else {
            setValidEmail(false);
        }

        if (expRegEmail.test(companyEmail)) {
            setValidCompanyEmail(true);
        } else {
            setValidCompanyEmail(false);
        }

        if (expRegEmail.test(legalRepresentativeEmail)) {
            setValidLegalRepresentativeEmail(true);
        } else {
            setValidLegalRepresentativeEmail(false);
        }
    }, [email, companyEmail, legalRepresentativeEmail])

    useEffect(() => {
        setShowEmptyFieldsMessage(false);
        if (validEmail) {
            if (email === repetEmail) {
                setValidRepetEmail(true)
            } else {
                setValidRepetEmail(false);
            }
        }

        if (validCompanyEmail) {
            if (companyEmail === companyRepetEmail) {
                setValidCompanyRepetEmail(true)
            } else {
                setValidCompanyRepetEmail(false);
            }
        }

    }, [validEmail, repetEmail, validCompanyEmail, companyRepetEmail])

    useEffect(() => {

        setShowEmptyFieldsMessage(false);
        const expRegPassword = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$");

        if (expRegPassword.test(password)) {
            setValidPassword(true);
            setShowErrorPasswordMessage(false);
        } else {
            setValidPassword(false);
        }

        if (expRegPassword.test(companyPassword)) {
            setValidCompanyPassword(true);
            setShowErrorCompanyPasswordMessage(false);
        } else {
            setValidCompanyPassword(false);
        }
    }, [password, companyPassword])


    const validateUnderAge = () => {
        const date = `${selectedDay?.year}/${selectedDay?.month}/${selectedDay?.day}`
        const age = getAge(date);
        if (age < 18) {
            setIsUnderAge(true);
            return true;
        } else {
            setIsUnderAge(false);
            return false;
        }
    }


    const registerInfluencer = () => {

        if (!validPassword) {
            setShowErrorPasswordMessage(true);
        } else {
            setShowErrorPasswordMessage(false);
        }

        if (validInfluencerName && validInfluencerLastName && validEmail && validRepetEmail && validPassword && influencerId?.length > 0 && selectedDay !== null && gender?.length > 0 && policyChecked && typeInfluencerLanguage) {

            const isUnderAge = validateUnderAge();
            if (!isUnderAge) {
                const influencerBody = {
                    mail: email.toLowerCase(),
                    password: password,
                    gender: gender,
                    birthday_: `${selectedDay.year}-${(selectedDay.month < 10) ? '0' + selectedDay.month : selectedDay.month}-${(selectedDay.day < 10) ? '0' + selectedDay.day : selectedDay.day}`,
                    givenName: influencerName.toLowerCase().trim(),
                    familyName: influencerLastName.toLowerCase().trim(),
                    attributes: {
                        typeUser: "Influencer",
                        typeId: typeInfluencerId.toString(),
                        primarylanguage: typeInfluencerLanguage,
                        numberId: influencerId,
                        active: true,
                        status: "ACTIVO",
                        verified: false,
                        twoStepVerification: false,
                        paypal: false
                    },
                    notification: {
                        colaborations: false,
                        promotions: true
                    }
                }

                setBody(influencerBody);
                setShowSecurityCode(true);
            }
        } else {
            setShowEmptyFieldsMessage(true);
        }
    }

    const registerUnderAgeInfluencer = () => {

        if (!validPassword) {
            setShowErrorPasswordMessage(true);
        } else {
            setShowErrorPasswordMessage(false);
        }

        if (isUnderAge) {
            if (validInfluencerName && validInfluencerLastName && validEmail && validRepetEmail && validPassword && influencerId.length > 0 && selectedDay !== null && gender.length > 0 && validLegalRepresentativeName && validLegalRepresentativeLastName && validLegalRepresentativeEmail && validLegalRepresentativePhone && relationship.length > 0 && typeInfluencerLanguage) {

                const influencerBody = {
                    mail: email.toLowerCase(),
                    password: password,
                    gender: gender,
                    birthday_: `${selectedDay.year}-${(selectedDay.month < 10) ? '0' + selectedDay.month : selectedDay.month}-${(selectedDay.day < 10) ? '0' + selectedDay.day : selectedDay.day}`,
                    givenName: influencerName.toLowerCase().trim(),
                    familyName: influencerLastName.toLowerCase().trim(),
                    attributes: {
                        typeUser: "Influencer",
                        typeId: typeInfluencerId.toString(),
                        primarylanguage: typeInfluencerLanguage,
                        numberId: influencerId,
                        active: true,
                        verified: false,
                        twoStepVerification: false,
                        paypal: false
                    },
                    notification: {
                        colaborations: false,
                        promotions: true
                    },
                    givenNameL: legalRepresentativeName.toLowerCase().trim(),
                    familyNameL: legalRepresentativeLastName.toLowerCase().trim(),
                    mailL: legalRepresentativeEmail.toLowerCase(),
                    phoneNumberL: legalRepresentativePhone,
                    indicativeL: legalRepresentativeIndicativePhone.toString(),
                    relationship: relationship
                }

                setBody(influencerBody);
                setShowSecurityCode(true);
            } else {
                setShowEmptyFieldsMessage(true);
            }
        }

    }


    const registerCompany = () => {

        if (!validCompanyPassword) {
            setShowErrorCompanyPasswordMessage(true);
        } else {
            setShowErrorCompanyPasswordMessage(false);
        }

        if (validCompanyEmail && validCompanyRepetEmail && validCompanyPassword && validCompanyName && policyChecked && typeInfluencerLanguage) {
            const companyBody = {
                mail: companyEmail.toLowerCase(),
                password: companyPassword,
                nameCompany: companyName.toLowerCase().trim(),
                attributes: {
                    typeUser: "company",
                    active: true,
                    primarylanguage: typeInfluencerLanguage,
                    verified: false,
                    twoStepVerification: false,
                    paypal: false
                },
                notification: {
                    colaborations: false,
                    promotions: true
                }
            }

            setBody(companyBody);
            setShowSecurityCode(true);
        } else {
            setShowEmptyFieldsMessage(true);
        }

    }


    const renderCustomInput = ({ ref }) => (
        <input
            readOnly
            ref={ref}
            placeholder={intl.formatMessage({ id: "signup_datepicker" })}
            value={selectedDay ? `${selectedDay.day}/${selectedDay.month}/${selectedDay.year}` : ''}
            style={{
                padding: '9px',
                border: '1px solid #BCBCBC',
                borderRadius: '10px',
                width: '100%',
                outline: 'none',
                fontFamily: 'Open Sans',
            }}
            className='inputPicker'
        />
    );

    const changeUser = () => {
        if (activeUser === 'influencer') {
            setActiveUser('company')
        } else {
            setActiveUser('influencer')
        }
    }


    const selectPhoneStyles = {
        control: (styles) => ({
            ...styles, borderRadius: '10px',
            boxShadow: 'none', height: '38px', minHeight: '34px', flexWrap: 'no-wrap', minWidth: '60px'

        }),
        indicatorSeparator: () => ({
            display: 'none'
        }),
        input: (styles) => ({ ...styles }),
        placeholder: (styles) => ({
            ...styles, fontSize: '1rem',
            "@media(max-width: 1540px)": {
                ...styles,
                fontSize: '0.9rem',
            }, "@media(max-width: 1366px)": {
                ...styles,
                fontSize: '0.8rem',
            }
        }),
        singleValue: (styles) => ({
            ...styles, fontSize: '1rem',
            "@media(max-width: 1540px)": {
                ...styles,
                fontSize: '0.9rem',
            }, "@media(max-width: 1366px)": {
                ...styles,
                fontSize: '0.8rem',
            }
        }),
        dropdownIndicator: (styles) => ({
            ...styles, color: '#E8339E'
        })
    };

    /**REVISAR */
    const selectIndentificationStyles = {
        control: (styles) => ({
            ...styles, borderRadius: '10px',
            boxShadow: 'none', height: '46px', minHeight: '34px', flexWrap: 'no-wrap', minWidth: '240px',
            "@media(max-width: 1540px)": {
                minWidth: '220px',
                height: '44px'
            },
            "@media(max-width: 1366px)": {
                minWidth: '200px',
                height: '41px'
            },
            "@media(max-width: 620px)": {
                minWidth: '180px',
                height: '39px'
            },
            "@media(max-width: 370px)": {
                minWidth: '170px',
                height: '38px'
            }

        }),
        indicatorSeparator: () => ({
            display: 'none'
        }),
        input: (styles) => ({ ...styles }),
        placeholder: (styles) => ({
            ...styles, fontSize: '1.1rem',
            fontWeight: 'bold',
            color: 'rgba(112,112,112)',
            opacity: '0.5',
            "@media(max-width: 1540px)": {
                fontSize: '1rem',
            }, "@media(max-width: 1366px)": {
                fontSize: '0.9rem',
            }, "@media(max-width: 620px)": {
                fontSize: '0.8rem',
            }
        }),
        singleValue: (styles) => ({
            ...styles, fontSize: '1.1rem',
            "@media(max-width: 1540px)": {
                fontSize: '1rem',
            }, "@media(max-width: 1366px)": {
                fontSize: '0.9rem',
            }, "@media(max-width: 620px)": {
                fontSize: '0.8rem',
            }
        }),
        menuList: (styles) => ({
            ...styles, fontSize: '1.1rem', color: 'rgba(112,112,112,0.51)',
            "@media(max-width: 1540px)": {
                fontSize: '1rem',
            }, "@media(max-width: 1366px)": {
                fontSize: '0.9rem',
            }, "@media(max-width: 620px)": {
                fontSize: '0.8rem',
            }
        }),
        dropdownIndicator: (styles) => ({
            ...styles, color: '#E8339E', "@media(max-width: 620px)": {
                padding: '4px'
            }
        }),
        valueContainer: (styles) => ({
            ...styles, "@media(max-width: 370px)": {
                paddingRight: '0px'
            }
        })

    };



    return (
        <SignUpContainer>
            <form action="submit" >
                <div className="header">
                    {(isUnderAge) ? (<h2 className="title"><FormattedMessage id="underAge_modal_title" defaultMessage="Por ser menor de edad" /></h2>) : (<h2 className="title"><FormattedMessage id="signup_title" defaultMessage="Regístrate" /></h2>)}

                    <Link to='/'>
                        <img src={close} alt="close" className="close" />
                    </Link>
                </div>
                {(isUnderAge) ? (<p className="relationshipTitle"><FormattedMessage id="underAge_modal_text_1" defaultMessage="Debemos solicitar datos extra" /></p>) : (<p className="message"><FormattedMessage id="signup_text_1" defaultMessage="Es rápido y sencillo" /></p>)}

                <div className="buttons">
                    <button type="button" className={`generalButton ${(activeUser === 'influencer') && 'active'}`} onClick={changeUser}>
                        <FormattedMessage id="signup_button_1" defaultMessage="Influencer" />
                    </button>
                    <button type="button" className={`generalButton ${(activeUser === 'company') && 'active'}`} onClick={changeUser}>
                        <FormattedMessage id="signup_button_2" defaultMessage="Empresa" />
                    </button>
                </div>
                {(activeUser === 'influencer') ? (
                    <>
                        {(isUnderAge) ? (<>
                            <p className="genderTitle"><FormattedMessage id="underAge_modal_text_2" defaultMessage="Nombre de un representante legal" /></p>

                            <div className="name">

                                <div className="inputContainer">
                                    <input className="influencerName" type="text" placeholder={intl.formatMessage({ id: "signup_input_1" })} onChange={(event) => { setLegalRepresentativeName(event.target.value) }} value={legalRepresentativeName} />

                                    {(validLegalRepresentativeName) && (<img src={check_circle} alt="password" className="check" />)}
                                </div>

                                <div className="inputContainer">
                                    <input className="influencerName" type="text" placeholder={intl.formatMessage({ id: "signup_input_2" })} onChange={(event) => { setLegalRepresentativeLastName(event.target.value) }} value={legalRepresentativeLastName} />
                                    {(validLegalRepresentativeLastName) && (<img src={check_circle} alt="password" className="check" />)}

                                </div>

                            </div>

                            <div className="inputContainer">
                                <input className="email" type="email" placeholder={intl.formatMessage({ id: "signup_input_3" })} onChange={(event) => { setLegalRepresentativeEmail(event.target.value) }} value={legalRepresentativeEmail} />
                                {(validLegalRepresentativeEmail) && (<img src={check_circle} alt="password" className="check" />)}
                            </div>

                            <div className="phone">
                                <Select options={indicativesOptions}
                                    styles={selectPhoneStyles}
                                    placeholder={intl.formatMessage({ id: "myAccount_text_5" })}
                                    defaultValue={indicativesOptions[0]}
                                    onChange={(event) => {
                                        setLegalRepresentativeIndicativePhone(event.label)
                                    }}
                                />
                                <div className="inputContainer">

                                    <input className="phone" type="number" placeholder={intl.formatMessage({ id: "underAge_modal_input_4" })} onChange={(event) => { setLegalRepresentativePhone(event.target.value) }} value={legalRepresentativePhone} />
                                    {(validLegalRepresentativePhone) && (<img src={check_circle} alt="password" className="check" />)}
                                </div>
                            </div>


                            <p className="relationshipTitle"><FormattedMessage id="underAge_modal_text_3" defaultMessage="Parentesco" /></p>

                            <div className="relationships">
                                <div className="relationship">
                                    <label htmlFor="mother" >
                                        <FormattedMessage id="underAge_modal_text_3_subtext_1" defaultMessage="Madre" />
                                    </label>
                                    <input type="radio" id="mother" name="relationship" value="mother" onClick={(e) => { setRelationship(e.target.value) }} />
                                </div>
                                <div className="relationship">
                                    <label htmlFor="father" >
                                        <FormattedMessage id="underAge_modal_text_3_subtext_2" defaultMessage="Padre" />
                                    </label>
                                    <input type="radio" id="male" name="relationship" value="father" onClick={(e) => { setRelationship(e.target.value) }} />
                                </div>
                                <div className="relationship">
                                    <label htmlFor="other" >
                                        <FormattedMessage id="underAge_modal_text_3_subtext_3" defaultMessage="Otro" />
                                    </label>
                                    <input type="radio" id="other" name="relationship" value="other" onClick={(e) => { setRelationship(e.target.value) }} />
                                </div>
                            </div>
                        </>) : (<>
                            <div className="name">

                                <div className="inputContainer">
                                    <input className="influencerName" type="text" placeholder={intl.formatMessage({ id: "signup_input_1" })} onChange={(event) => { setInfluencerName(event.target.value) }} />
                                    {(validInfluencerName) && (<img src={check_circle} alt="password" className="check" />)}
                                </div>

                                <div className="inputContainer">
                                    <input className="influencerLastName" type="text" placeholder={intl.formatMessage({ id: "signup_input_2" })} onChange={(event) => { setInfluencerLastName(event.target.value) }} />
                                    {(validInfluencerLastName) && (<img src={check_circle} alt="password" className="check" />)}
                                </div>

                            </div>

                            <div className="inputContainer">
                                <input className="email" type="email" placeholder={intl.formatMessage({ id: "signup_input_3" })} onChange={(event) => { setEmail(event.target.value) }} value={email} />
                                {(validEmail) && (<img src={check_circle} alt="password" className="check" />)}
                            </div>

                            {(validEmail) && (<div className="inputContainer">
                                <input className="email" type="email" placeholder={intl.formatMessage({ id: "signup_input_4" })} onChange={(event) => { setRepetEmail(event.target.value) }} value={repetEmail} />
                                {(validRepetEmail) && (<img src={check_circle} alt="password" className="check" />)}
                            </div>)}

                            <div className="inputContainer">
                                <input className="password" type={(seePassword) ? "text" : "password"} placeholder={intl.formatMessage({ id: "signin_input_2" })} onChange={(event) => { setPassword(event.target.value) }} value={password} />

                                <img src={(seePassword) ? eye : slashEye} alt="password" className="icon" onClick={() => { setSeePassword(!seePassword) }} />
                                {(validPassword) && (<img src={check_circle} alt="password" className="check" />)}
                            </div>
                            {(showErrorPasswordMessage) && (<p className="error"> <FormattedMessage id="sign_up_error_password_message" defaultMessage="La contraseña debe contener al menos una mayuscula a minuscula un numero y entre 8 y 10 caracteres" /> </p>)}

                            {(validPassword) && (<div className="influencerIdContainer">
                                <Select options={identificationTypes}
                                    styles={selectIndentificationStyles}
                                    placeholder={intl.formatMessage({ id: "myAccount_text_6" })}
                                    onChange={(event) => {
                                        setTypeInfluencerId(event.value)
                                    }}
                                />
                                <input className="influencerId" type="text" placeholder={intl.formatMessage({ id: "signup_input_6" })} onChange={(event) => { setInfluencerId(event.target.value) }} />
                            </div>)}

                            <p className="birthdayTitle"><FormattedMessage id="signup_text_2" defaultMessage="Fecha de nacimiento" /></p>

                            <div className="date">
                                <DatePicker
                                    value={selectedDay}
                                    onChange={setSelectedDay}
                                    calendarClassName="custom-calendar"
                                    renderInput={renderCustomInput}
                                    colorPrimary="#E8339E"
                                    maximumDate={utils().getToday()}

                                /* renderFooter={() => (
                                    <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: '20px' }}>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                setSelectedDay(null)
                                            }}
                                            style={{
                                                border: '#0fbcf9',
                                                color: '#fff',
                                                borderRadius: '0.5rem',
                                                padding: '10px 20px',
                                                backgroundColor: '#E8339E',
                                                margin: '0'
                                            }}
                                        >
                                            <FormattedMessage id="modal_prices_text_5" defaultMessage="Restablecer valor" />
                                        </button>
                                    </div>
                                )} */
                                />

                            </div>

                            <p className="genderTitle"><FormattedMessage id="signup_text_3" defaultMessage="Género" /></p>
                            <div className="genders">
                                <div className="gender">
                                    <label htmlFor="female" >
                                        <FormattedMessage id="signup_text_3_subtext_1" defaultMessage="Female" />
                                    </label>
                                    <input type="radio" id="female" name="gender" value="female" onClick={(e) => {
                                        setGender(e.target.value);
                                        setShowCustomPronoun(false);
                                    }} />
                                </div>
                                <div className="gender">
                                    <label htmlFor="male" >
                                        <FormattedMessage id="signup_text_3_subtext_2" defaultMessage="Male" />
                                    </label>
                                    <input type="radio" id="male" name="gender" value="male" onClick={(e) => {
                                        setGender(e.target.value);
                                        setShowCustomPronoun(false);
                                    }} />
                                </div>
                                <div className="gender">
                                    <label htmlFor="other" >
                                        <FormattedMessage id="signup_text_3_subtext_3" defaultMessage="Otro" />
                                    </label>
                                    <input type="radio" id="other" name="gender" value="other" onClick={() => {
                                        setGender('');
                                        setShowCustomPronoun(true);
                                    }} />
                                </div>
                            </div>

                            {(showCustomPronoun) && (<input className="influencerPronoun" type='text' placeholder={intl.formatMessage({ id: "signup_select" })} value={gender} onChange={(event) => { setGender(event.target.value) }} />)}

                        </>)}

                        {(gender) && (<div>
                            <p className="birthdayTitle"><FormattedMessage id="signup_input_8" defaultMessage="Idioma de preferencia" /></p>

                            <Select options={primaryLanguageTypes}
                                styles={selectIndentificationStyles}
                                placeholder={intl.formatMessage({ id: "myAccount_text_8" })}
                                onChange={(event) => {
                                    setTypeInfluencerLanguage(event.value)
                                }}
                            />

                        </div>)}
                    </>
                ) : (
                    <>
                        <div className="inputContainer companyNameContainer">
                            <input className="companyName" type="text" placeholder={intl.formatMessage({ id: "signup_input_7" })} onChange={(event) => { setCompanyName(event.target.value) }} value={companyName} />
                            {(validCompanyName) && (<img src={check_circle} alt="password" className="check" />)}
                        </div>


                        <div className="inputContainer">
                            <input className="email" type="email" placeholder={intl.formatMessage({ id: "signup_input_3" })} onChange={(event) => { setCompanyEmail(event.target.value) }} value={companyEmail} />
                            {(validCompanyEmail) && (<img src={check_circle} alt="password" className="check" />)}
                        </div>

                        <div className="inputContainer">
                            <input className="email" type="email" placeholder={intl.formatMessage({ id: "signup_input_4" })} onChange={(event) => { setCompanyRepetEmail(event.target.value) }} value={companyRepetEmail} />
                            {(validCompanyRepetEmail) && (<img src={check_circle} alt="password" className="check" />)}
                        </div>

                        <div className="inputContainer">
                            <input type={(seePassword) ? "text" : "password"} placeholder={intl.formatMessage({ id: "signin_input_2" })} className="password" onChange={(event) => { setCompanyPassword(event.target.value) }} value={companyPassword} />
                            <img src={eye} alt="password" className="icon" onClick={() => { setSeePassword(!seePassword) }} />
                            {(validCompanyPassword) && (<img src={check_circle} alt="password" className="check" />)}
                        </div>

                        {(showErrorCompanyPasswordMessage) && (<p className="error"> <FormattedMessage id="sign_up_error_password_message" defaultMessage="La contraseña debe contener al menos una mayuscula a minuscula un numero y entre 8 y 10 caracteres" /> </p>)}
                    </>)}

                {(companyPassword) && (<div>
                    <p className="birthdayTitle"><FormattedMessage id="signup_input_8" defaultMessage="Idioma de preferencia" /></p>

                    <Select options={primaryLanguageTypes}
                        styles={selectIndentificationStyles}
                        placeholder={intl.formatMessage({ id: "myAccount_text_8" })}
                        onChange={(event) => {
                            setTypeInfluencerLanguage(event.value)
                        }}
                    />

                </div>)}
                {/* <p className="accept"> <FormattedMessage id="signup_text_4" defaultMessage="Al registrarte, aceptas las condiciones de servicio, las directrices de la comunidad y la política de privacidad de Fluincr." /></p> */}

                <div className="accept">
                    <input type="checkbox" className="inputAccept" value={policyChecked} onChange={(e) => {
                        setPolicyChecked(e.target.checked)
                    }} />
                    <p className="acceptText">
                        <span>
                            <FormattedMessage id="signup_text_4_a" defaultMessage="Al registrarte, aceptas las " />
                        </span>
                        <Link to={"/legal/terms"}>
                            <span>
                                <FormattedMessage id="signup_text_4_b" defaultMessage="condiciones de servicio" />
                            </span>
                        </Link>
                        <span>, </span>
                        <Link to={"/legal/guidelines"}>
                            <span>
                                <FormattedMessage id="signup_text_4_c" defaultMessage="las directrices de la comunidad " />
                            </span>
                        </Link>
                        <span>
                            <FormattedMessage id="signup_text_4_d" defaultMessage="y " />
                        </span>
                        <Link to={"/legal/policy"}>
                            <span>
                                <FormattedMessage id="signup_text_4_e" defaultMessage="la política de privacidad " />
                            </span>
                        </Link>

                        <span>
                            <FormattedMessage id="signup_text_4_f" defaultMessage="de Fluincr." />
                        </span>
                    </p>


                </div>

                <div className="registerButton">
                    {(isUnderAge) ? (<>
                        {(showEmptyFieldsMessage) && (<p className="error"><FormattedMessage id="sign_up_error_message" defaultMessage="Completar todos los campos" /></p>)}
                        <button className="generalButton active" type="button" onClick={registerUnderAgeInfluencer}>
                            <FormattedMessage id="underAge_modal_button_3" defaultMessage="Finalizar registro" />
                        </button>
                    </>
                    ) : (<>
                        {(showEmptyFieldsMessage) && (<p className="error"><FormattedMessage id="sign_up_error_message" defaultMessage="Completar todos los campos" /></p>)}
                        <button className="generalButton active register" type="button" onClick={() => {
                            if (activeUser === 'influencer') {
                                registerInfluencer()
                            }
                            if (activeUser === 'company') {
                                registerCompany()
                            }
                        }}>
                            <FormattedMessage id="signup_button_3" defaultMessage="Regístrate" />
                        </button>
                    </>)}

                </div>

            </form>

            {(showSecurityCode) && (<ModalSecurityCode setShowSecurityCode={setShowSecurityCode} body={body} activeUser={activeUser} setShowAlertSuccessful={setShowAlertSuccessful} setShowAlertUserExists={setShowAlertUserExists} />)}

            {(showAlertSuccessful) && (<Alert
                title={<FormattedMessage id="alert_register_title" defaultMessage="¡Felicitaciones!" />}
                text={<FormattedMessage id="alert_register_text" defaultMessage="Tu cuenta fue creada exitosamente, da click a continuación para iniciar sesión." />}
                confirmText={<FormattedMessage id="header_button_text" defaultMessage="Iniciar sessión" />}
                setShowAlert={setShowAlertSuccessful}
                onConfirm={() => { navigate('/signin') }}
            />)}

            {(showAlertUserExists) && (<Alert
                title={<FormattedMessage id="alert_user_exists_title" defaultMessage="Advertencia" />}
                text={<FormattedMessage id="alert_user_exists_text" defaultMessage="Este correo ya está registrado. ¿Desea ingresar o crear una nueva cuenta?" />}
                confirmText={<FormattedMessage id="header_button_text" defaultMessage="Iniciar sessión" />}
                onConfirm={() => { navigate('/signin') }}
                cancelText={<FormattedMessage id="banner_button_text" defaultMessage="Regístrate" />}
                onCancel={() => {
                    setShowAlertUserExists(false);
                    setIsUnderAge(false);
                    navigate('/signup')
                }}
                setShowAlert={setShowAlertUserExists}

            />)}

        </SignUpContainer>
    )
}